import { createContext, useCallback, useContext, useEffect, useState } from "react";
import useSWR from "swr";
import { api, fetcher, getCustomerToken, setCustomerToken, clearCustomerToken } from "../lib/api";

const StoreCtx = createContext(null);
const SEL_KEY = "emaia_selection";

const loadSelection = () => {
  try {
    return JSON.parse(localStorage.getItem(SEL_KEY)) || [];
  } catch {
    return [];
  }
};

export function StoreProvider({ children }) {
  const { data: settings } = useSWR("/public/settings", fetcher, { refreshInterval: 60000 });
  const [hasAccess, setHasAccess] = useState(() => !!getCustomerToken());
  const [customer, setCustomer] = useState(null);
  const [selection, setSelection] = useState(loadSelection);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(SEL_KEY, JSON.stringify(selection));
  }, [selection]);

  useEffect(() => {
    if (!getCustomerToken()) return;
    api.get("/customers/me").then((r) => setCustomer(r.data)).catch((e) => {
      if (e.response?.status === 401) {
        clearCustomerToken();
        setHasAccess(false);
      }
    });
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("emaia_visit")) return;
    sessionStorage.setItem("emaia_visit", "1");
    api.post("/track/visit").catch(() => {});
  }, []);

  const grantAccess = (token, cust) => {
    setCustomerToken(token);
    setCustomer(cust);
    setHasAccess(true);
  };
  const forgetDevice = () => {
    clearCustomerToken();
    setCustomer(null);
    setHasAccess(false);
  };

  const toggleItem = useCallback((p) => {
    setSelection((s) =>
      s.some((i) => i.id === p.id)
        ? s.filter((i) => i.id !== p.id)
        : [...s, { id: p.id, slug: p.slug, name: p.name, brand: p.brand, volume_ml: p.volume_ml, final_price: p.final_price, image: p.images?.[0] || "", qty: 1 }]
    );
  }, []);
  const setQty = (id, qty) => setSelection((s) => s.map((i) => (i.id === id ? { ...i, qty: Math.max(1, Math.min(50, qty)) } : i)));
  const removeItem = (id) => setSelection((s) => s.filter((i) => i.id !== id));
  const isSelected = (id) => selection.some((i) => i.id === id);

  const value = {
    settings, hasAccess, customer, setCustomer, grantAccess, forgetDevice,
    selection, toggleItem, setQty, removeItem, isSelected, clearSelection: () => setSelection([]),
    drawerOpen, setDrawerOpen,
  };
  return <StoreCtx.Provider value={value}>{children}</StoreCtx.Provider>;
}

export const useStore = () => useContext(StoreCtx);
